import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { HomeRegimeFailure, HomeRegimeRequest, HomeRegimeSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'homeRegime';

export interface State {
  data: ParameterResult | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(HomeRegimeFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(HomeRegimeRequest, state => ({ ...state, error: null, loading: true })),
    on(HomeRegimeSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
